import {Injectable} from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class MappingService {

    private _linesHidden = new BehaviorSubject<boolean>(false);
    public linesHidden = this._linesHidden.asObservable();
    private _refreshLines = new BehaviorSubject<boolean>(false);
    public refreshLines = this._refreshLines.asObservable();

    public hideLines() {
        this._linesHidden.next(true);
    }

    public showLines() {
        this._linesHidden.next(false);
    }

    public refresh() {
        this._refreshLines.next(true);
    }
}
